export const accordion = () => {
  const $accordionLists = document.querySelectorAll("section.accordion-list");
  $accordionLists.forEach(($accordionList) => {
    const $accordianContents = $accordionList.querySelector(
      ".accordion-list__contents"
    );
    const $accordianTitle = $accordionList.querySelector(
      ".accordion-list__title "
    );

    const $accordions = $accordianContents.querySelectorAll(".accordion");
    $accordions.forEach(($accordion) => {
      const $accordionHeader = $accordion.querySelector(".accordion__header");
      const $accordionBody = $accordion.querySelector(".accordion__body");

      $accordionHeader.addEventListener("click", (event) => {
        event.preventDefault();
        if ($accordionBody.classList.contains("hidden")) {
          $accordionBody.classList.remove("hidden");
          $accordionHeader.classList.remove("rotate-90");
          $accordionHeader.classList.add("-rotate-90");
        } else {
          $accordionBody.classList.add("hidden");
          $accordionHeader.classList.remove("-rotate-90");
          $accordionHeader.classList.add("rotate-90");
        }
      });
    });
  });
};

export default accordion;
